import { connect } from "react-redux";
import {
  loaderStatusSelector,
  loaderTextSelector,
} from "redux-store/loader/selectors";

import { NavLoader } from "./nav-loader";

function mapStateToProps(state) {
  const isLoading = loaderStatusSelector(state);
  const children = loaderTextSelector(state);

  return {
    isLoading,
    children,
  };
}

const ConnectedNavLoader = connect(mapStateToProps)(NavLoader);

export { ConnectedNavLoader };
